// XISVEL web-vitals → GA4（CrUX 因站点流量不出数，自采真实用户体验：LCP/INP/CLS/TTFB）。
// 自包含 ~2KB，defer+fetchpriority=low，监听器全被动、上报走 gtag('event') 于页面隐藏时，
// 对 LCP/TBT/CLS 本身零感知。无 gtag/dataLayer 的环境（如未连 GA4 的店）静默 no-op。
// 事件契约：GA4 事件 web_vitals { metric_name: lcp|inp|cls|ttfb, value: 整数(cls 已 ×100), page_id, net }。
// LCP 弃报：后台标签页补绘样本（startTime 含挂起时长，可达小时级）与 >60s 异常值——防均值被天文值污染。
// QA：localStorage.setItem('_wv_debug','1') 后任意时刻可 window.__wvFlush() 即时上报并 console 输出。

let DEBUG = false;
try {
  DEBUG = localStorage.getItem('_wv_debug') === '1';
} catch {}

const PAGE_ID =
  (globalThis.crypto && crypto.randomUUID && crypto.randomUUID()) ||
  `wv-${Date.now()}-${Math.random()}`;

const sent = new Set();
const send = (name, value) => {
  if (sent.has(name) || !isFinite(value)) return;
  const hasGtag = typeof window.gtag === 'function';
  const hasDl = Array.isArray(window.dataLayer);
  if (!hasGtag && !hasDl) return; // 上报通道未就绪：保留未发状态，flush 时重试（防 ttfb 竞态丢失）
  sent.add(name);
  const v = name === 'cls' ? Math.round(value * 100) : Math.round(value);
  const params = {
    metric_name: name,
    value: v,
    page_id: PAGE_ID,
    net: (navigator.connection && navigator.connection.effectiveType) || '',
    non_interaction: true,
  };
  try {
    if (typeof window.gtag === 'function') window.gtag('event', 'web_vitals', params);
    else if (Array.isArray(window.dataLayer)) window.dataLayer.push({ event: 'web_vitals', ...params });
  } catch {}
  if (DEBUG) console.info('[wv]', name, v);
};

// TTFB 在解析期即已知，直接上报
try {
  const nav = performance.getEntriesByType('navigation')[0];
  if (nav && nav.responseStart > 0) send('ttfb', nav.responseStart);
} catch {}

// LCP：取最新候选值；首次输入或页面隐藏时定性（官方口径）。
// 后台标签页挂起期间浏览器不渲染，切回时才补绘——此时候选的 startTime 含整段挂起时长（小时级天文值）。
// 记录首次转入后台的时刻，凡在其后才绘制的 LCP 一律弃报（官方 web-vitals 库同款语义，不误伤正常样本）。
let lcp = 0;
let lcpFinal = false;
let firstHiddenAt = document.visibilityState === 'hidden' ? 0 : Infinity;
const finalizeLcp = () => {
  if (lcpFinal) return;
  lcpFinal = true;
  // lcp=0（无候选/无 API）不上报；>60s 兜底休眠恢复等可见性钩子覆盖不到的异常，已无诊断价值
  if (lcp > 0 && firstHiddenAt >= lcp && lcp <= 60000) send('lcp', lcp);
};
try {
  new PerformanceObserver((list) => {
    if (lcpFinal) return;
    const entries = list.getEntries();
    const last = entries[entries.length - 1];
    if (last && last.startTime > lcp) lcp = last.startTime;
  }).observe({ type: 'largest-contentful-paint', buffered: true });
  addEventListener('pointerdown', finalizeLcp, { once: true, passive: true });
  addEventListener('keydown', finalizeLcp, { once: true, passive: true });
} catch {}
// 须先于下方 flush 的 visibilitychange 监听注册：隐藏瞬间先记 firstHiddenAt、后结算 LCP，顺序才正确
addEventListener('visibilitychange', () => {
  if (document.visibilityState === 'hidden' && firstHiddenAt === Infinity) {
    firstHiddenAt = performance.now();
  }
});

// INP：按 interactionId 聚合单次交互最长时延，整页取最差交互（官方 p98 口径的保守上界）
const interactions = new Map();
try {
  new PerformanceObserver((list) => {
    for (const e of list.getEntries()) {
      if (e.interactionId == null) continue;
      interactions.set(e.interactionId, Math.max(interactions.get(e.interactionId) || 0, e.duration));
    }
  }).observe({ type: 'event', durationThreshold: 40, buffered: true });
} catch {}

// CLS：会话窗口（1s 间隙闭合 / 5s 窗口上限），整页取最大窗口值——对齐官方库口径
let clsMax = 0;
let clsWindow = { value: 0, first: 0, last: 0 };
try {
  new PerformanceObserver((list) => {
    for (const e of list.getEntries()) {
      if (e.hadRecentInput) continue;
      if (e.startTime - clsWindow.last > 1000 || e.startTime - clsWindow.first > 5000) {
        clsMax = Math.max(clsMax, clsWindow.value);
        clsWindow = { value: 0, first: e.startTime, last: e.startTime };
      }
      clsWindow.value += e.value;
      clsWindow.last = e.startTime;
    }
  }).observe({ type: 'layout-shift', buffered: true });
} catch {}

// 页面隐藏时统一结算（每指标只报一次；bfcache 恢复由 sent 去重兜底）
const flush = () => {
  try {
    const nav = performance.getEntriesByType('navigation')[0];
    if (nav && nav.responseStart > 0) send('ttfb', nav.responseStart);
  } catch {}
  if (!lcpFinal) finalizeLcp();
  let inp = 0;
  for (const d of interactions.values()) inp = Math.max(inp, d);
  if (interactions.size > 0) send('inp', inp);
  send('cls', Math.max(clsMax, clsWindow.value));
};
addEventListener('visibilitychange', () => {
  if (document.visibilityState === 'hidden') flush();
});
addEventListener('pagehide', flush);
window.__wvFlush = flush;
